<div class="w100 flex-direction-row flex-start-center">
  <div style="width: 100px;height: 100%">
    @if (device?.photoUrl!=null) {
      <img src="{{device?.photoUrl}}" class="principal-image">
    } @else {
      <mat-icon class="icon-size-large" style="color: white">add_a_photo</mat-icon>
    }
  </div>
  <div class="flex-start-center flex-direction-column" style="width: calc(100% - 100px)">
    @if (device?.name!=null) {
      <div class="w100 flex-center-center flex-direction-row">
        @if ((device|transformValueByPredicateFunction:getDifferenceHourWithNowPredicate:indexData)>2) {
          <mat-icon color="accent" style="margin: 0 10px"
            >
            warning
          </mat-icon>
        }
        <h2 style="padding: unset;margin: unset">{{device?.name}}</h2>
        <div>
          <ng-content select="[bottom]">
          </ng-content>
        </div>
      </div>
    }
    <div class="w100">
      <div style="display: flex;align-items: center;justify-content: center;">
        <mat-card
          style="margin: 5px;color: white;min-width: 165px"
          [ngClass]="device|transformValueByPredicateFunction:getSensorDataClass:indexData">
          <mat-card-content>
            <span style="font-weight: bold">
              {{device|transformValueByPredicateFunction:getSensorDataTraduction:indexData |translate}}
              <!--                            <mat-icon style="margin-bottom: -8px">arrow_drop_down</mat-icon>-->
            </span>
            <h2>{{(device|transformValueByPredicateFunction:getSensorDataValuePredicate:indexData)|unitOfMeasurement:sensorDataType:2}}</h2>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<!--<mat-menu #menu="matMenu">-->
<!--    <button mat-menu-item *ngFor="let type of device|transformValueByPredicateFunction:getSensorDataTypesPredicate"-->
<!--            (click)="setIndex(type.value)">-->
<!--        <span>{{type.traduction|translate}}</span>-->
<!--    </button>-->
<!--</mat-menu>-->
